import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ICompleteEnglishIqV1Request } from './complete-english-iq-v1-request';
import type { ICompleteEnglishIqV1Response } from './complete-english-iq-v1-response';
import { completeEnglishIqV1ResponseSchema } from './complete-english-iq-v1-response';

export async function completeEnglishIqV1Api(
  body: ICompleteEnglishIqV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ICompleteEnglishIqV1Response>> {
  return postRequest<ICompleteEnglishIqV1Response>({
    body,
    options,
    path: '/english-iq/complete/v1',
    schema: completeEnglishIqV1ResponseSchema,
  });
}
